module.exports = __webpack_public_path__ + "static/img/title.718b02f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/title.png
// module id = yP4d
// module chunks = 1